<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="4"
        lg="4"
        offset-lg="3"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <!-- form -->
            <b-form>
              <validation-observer
                ref="settingsform"
                tag="form"
              >
                <b-row>
                  <b-col sm="12">

                    <b-form-group
                      :label="$t('DEBTIA_DEFAULT_KEY')"
                      label-for="default-default"
                    >
                      <v-select
                        v-model="selected"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="settingKeysOptions"
                        :reduce="val => val.value"
                        :clearable="false"
                        input-id="default-default"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'default_termsheetcode'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="termsheetCodeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'is_default_interest_rate'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="generalOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'debtors_own_by'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="debtorsOwnByOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'maximum_reminder_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Maximum Reminder Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'maximum_compensation_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Maximum Compensation Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'minimum_case_amount'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Minimum Case Amount"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'transfer_court_fee'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Transfer Court Fee"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'foreign_collection_cost'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Foreign Collection Cost"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row
                  v-if="selected == 'own_collection_cost'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Own Collection Cost"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'conclude_bailiff_client'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Bailiff to Client Statement"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'conclude_bailiff_us'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <b-form-input
                          v-model="settingsData.value"
                          placeholder="Bailiff to Client Statement"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'overvagning_termsheet'"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="termsheetCodeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'client_own_reminder_fee'"
                  :key="selected"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('CLIENT_OWN_REMINDER_FEE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="clientReminderFee"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="clientReminderFeeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'eboks_enabled'"
                  :key="selected"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="generalOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'apply_vat_exemption'"
                  :key="selected"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="generalOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row
                  v-if="selected == 'restrict_full_payment_actions'"
                  :key="selected"
                >
                  <b-col sm="12">
                    <validation-provider
                      #default="{ errors }"
                      name="Default Value"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_DEFAULT_VALUE')"
                        label-for="default_value"
                      >
                        <v-select
                          v-model="settingsData.value"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="generalOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="default-value"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      block
                      variant="primary"
                      @click="postSettingValues"
                    >
                      Save
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
          <!--/ form -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BFormGroup, BButton, BForm, BOverlay, BFormInput,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
    BOverlay,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      clientReminderFee: 0,
      selected: 'debtors_own_by',
      debtorsOwnByOptions: [
        { label: 'Company', value: 'company' },
        { label: 'Client', value: 'client' },
      ],
      termsheetCodeOptions: [],
      settingsData: {
        key: '',
        value: 0,
      },
      generalOptions: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      loader: false,
      clientReminderFeeOptions: [],
      required,
    }
  },
  computed: {
    settingKeysOptions() {
      return [
        { label: this.$t('DEBTORS_OWN_BY'), value: 'debtors_own_by' },
        { label: this.$t('DEFAULT_TERMSHEET_CODE'), value: 'default_termsheetcode' },
        { label: this.$t('IS_DEFAULT_INTEREST_RATE'), value: 'is_default_interest_rate' },
        { label: this.$t('MAX_COMPENSATION_FEE'), value: 'maximum_compensation_fee' },
        { label: this.$t('MAX_REMINDER_FEE'), value: 'maximum_reminder_fee' },
        { label: this.$t('MIN_CASE_AMOUNT'), value: 'minimum_case_amount' },
        { label: this.$t('TRANSFER_COURT_FEE'), value: 'transfer_court_fee' },
        { label: this.$t('FOREIGN_COLLECTION_COST'), value: 'foreign_collection_cost' },
        { label: this.$t('OWN_COLLECTION_COST'), value: 'own_collection_cost' },
        { label: this.$t('CONCLUDE_BAILIFF_CLIENT'), value: 'conclude_bailiff_client' },
        { label: this.$t('CONCLUDE_BAILIFF_US'), value: 'conclude_bailiff_us' },
        { label: this.$t('OVERVAGNING_TERMSHEET'), value: 'overvagning_termsheet' },
        { label: this.$t('CLIENT_OWN_REMINDER_FEE'), value: 'client_own_reminder_fee' },
        { label: this.$t('EBOKS_ENABLED'), value: 'eboks_enabled' },
        { label: this.$t('RESTRICT_FULL_PAYMENT_ACTIONS'), value: 'restrict_full_payment_actions' },
        { label: this.$t('APPLY_VAT_EXEMPTION'), value: 'apply_vat_exemption' },
      ]
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(newValue) {
        this.getSettingValues(newValue)
        if (newValue === 'client_own_reminder_fee') this.getClientsReminderFeeOptions()
      },
    },
  },
  created() {
    this.getSettingValues('debtors_own_by')
    this.getTermsheetcodeDropdown()
  },
  methods: {
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    getSettingValues(selected) {
      this.loader = true
      axios.get('user-settings/get', { params: { key: selected } }).then(response => {
        const settingDetails = response.data.data
        // console.log('settingDetails', settingDetails)
        this.settingsData.key = selected
        // console.log('selected is ', settingDetails.value)
        if (!settingDetails || settingDetails === null) {
          this.getDefaultValues(selected)
        } else if (['is_default_interest_rate', 'eboks_enabled', 'restrict_full_payment_actions', 'apply_vat_exemption'].includes(selected)) {
          if (settingDetails.value === '1') {
            this.settingsData.value = true
          } else if (settingDetails.value === '0') {
            this.settingsData.value = false
          }
        } else {
          this.settingsData.value = settingDetails.value
        }
        this.loader = false
      }).catch(() => {
        this.getDefaultValues(selected)
        this.loader = false
      })
    },
    getTermsheetcodeDropdown() {
      this.loader = true
      axios.get('settings/termsheetcode-dropdown').then(response => {
        const settingDetails = response.data.data
        if (settingDetails !== null) {
          this.termsheetCodeOptions = response.data.data
        }
        this.loader = false
      })
    },
    getClientsReminderFeeOptions() {
      this.loader = true
      axios.get('settings/get-statements-dropdown').then(response => {
        const options = response.data.data
        if (options !== null) {
          const selectedItem = this.settings.find(item => item.key === 'client_own_reminder_fee')
          const filteredOption = options.filter(item => item.label !== '0000' && item.label !== '1000')
          this.clientReminderFeeOptions = filteredOption

          this.clientReminderFee = 1004
          if (selectedItem && Object.keys(selectedItem).length > 0) {
            this.clientReminderFee = Number(selectedItem.value)
          }
        }
        this.loader = false
      })
    },
    getDefaultValues(key) {
      if (key === 'debtors_own_by') {
        this.settingsData.value = 'company'
      } if (key === 'default_termsheetcode') {
        this.settingsData.value = ''
      } if (key === 'is_default_interest_rate') {
        this.settingsData.value = true
      } if (key === 'apply_vat_exemption') {
        this.settingsData.value = false
      } if (key === 'overvagning_termsheet') {
        this.settingsData.value = ''
      } if (key === 'debt_payment_options') {
        this.settingsData.value = ''
      } if (key === 'eboks_enabled') {
        this.settingsData.value = false
      } if (key === 'restrict_full_payment_actions') {
        this.settingsData.value = false
      }
    },
    postSettingValues() {
      return new Promise((resolve, reject) => {
        this.$refs.settingsform.validate().then(success => {
          if (success) {
            this.settingsData.key = this.selected
            if (this.selected === 'client_own_reminder_fee') {
              this.settingsData.value = Number(this.clientReminderFee)
            }
            this.loader = true
            axios.post('user-settings/save', [this.settingsData]).then(response => {
              this.loader = false
              const selectedItem = this.settings.find(item => item.key === 'client_own_reminder_fee')
              if (selectedItem && Object.keys(selectedItem).length > 0) {
                selectedItem.value = Number(this.clientReminderFee)
              }
              if (response.data.data[0].key === 'debtors_own_by') {
                localStorage.setItem('debtorsBelongTo', response.data.data[0].value)
              }
              this.makeSuccessToast()
              resolve(true)
            })
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
